module.exports = __webpack_public_path__ + "static/logo-57634ab214691bb46d0f1956946175c8.svg";